import { atom } from 'recoil'

export const gameState = atom({
  key: 'gameState',
  default: {
    id: null,
    state: 'LOADING',
    startDate: null,
    endDate: null,
    result: null,
    bets: [],
    history: [],
    elapsed: null,
  },
})

export const modalState = atom({
  key: 'modalState',
  default: null,
})

export const userState = atom({
  key: 'userState',
  default: {
    username: null,
    balance: null,
    currentBet: null,
    state: 'IDLE',
    isLoggedIn: false,
    address: null,
    tag: null,
  },
})

export const chatState = atom({
  key: 'chatState',
  default: [],
})
